"use client";

import { Suspense } from "react";
import {
  ForgotPasswordPageContent,
  ForgotPasswordPageFallback,
} from "@/components/pages/ForgotPasswordPageContent";

export default function ForgotPasswordPage() {
  return (
    <Suspense fallback={<ForgotPasswordPageFallback />}>
      <ForgotPasswordPageContent />
    </Suspense>
  );
}
